import trans from "../utils";

export function SpeedUnit(number, unit) {
	const num = Number(number);
	if (isNaN(num)) return `0 ${trans(unit || "kn")}`;
	if (unit === "kmh") {
		return `${Math.floor(num * 1.852)} ${trans("km/h")}`;
	} else if (unit === "mph") {
		return `${(num * 1.15078).toFixed(0)} ${trans("mph")}`;
	} else {
		return `${num.toFixed(0)} ${trans("kn")}`;
	}
}

export function SpeedInputValue(number, unit) {
  console.log("number", number);

  if (number === null || number === undefined) return number; 

  const num = Number(number);
  if (isNaN(num)) return;

  if (unit === "kmh") {
    return num / 1.852;
  } else if (unit === "mph") {
    return num / 1.15078;
  } else {
    return num;
  }
}

export function SpeedValue(number, unit) {
	console.log("numbe2r",number)
  if (number === null || number === undefined) return number; 
  const num = Number(number);
  if (isNaN(num)) return;
	if (unit === "kmh") {
		return Math.floor(num * 1.852);
	} else if (unit === "mph") {
		return Math.floor(num * 1.15078);
	} else {
		return num;
	}
}

export function DistanceUnit(number, unit) {
	const num = Number(number);
	if (isNaN(num)) return `0 ${trans(unit || "km")}`;

	if (unit === "km") {
		return `${Math.floor(num / 1000)} ${trans("km")}`;
	} else if (unit === "mi") {
		return `${Math.floor(num * 0.000621371)} ${trans("mi")}`;
	} else if (unit === "nmi") {
		return `${Math.floor(num * 0.000539957)} ${trans("nmi")}`;
	} else {
		return `${(num / 1000).toFixed(0)} ${trans("km")}`;
	}
}

export function AltitudeUnit(number, unit) {
	const num = Number(number);
	if (isNaN(num)) return `0 ${trans(unit || "m")}`;

	if (unit === "m") {
		return `${Math.floor(num)} ${trans("m")}`;
	} else if (unit === "ft") {
		return `${Math.floor(num * 3.28084)} ${trans("ft")}`;
	} else {
		return `${num.toFixed(0)} ${trans("m")}`;
	}
}

export function VolumeUniit(number, unit) {
	const num = Number(number);
	if (isNaN(num)) return `0 ${trans(unit || "ltr")}`;

	if (unit === "ltr") {
		return `${num.toFixed(2)} ${trans("ltr")}`;
	} else if (unit === "usGal") {
		return `${(num * 0.264172).toFixed(2)} ${trans("usGal")}`;
	} else if (unit === "impGal") {
		return `${(num * 0.219969).toFixed(2)} ${trans("impGal")}`;
	} else {
		return `${num.toFixed(2)} ${trans("ltr")}`;
	}
}
export function VolumeInputValue(number, unit) {
  if (number === null || number === undefined || number === "") {
    return number;
  }

  const num = Number(number);
  if (isNaN(num)) return;

  if (unit === "usGal") {
    return num / 0.264172;
  } else if (unit === "impGal") {
    return num / 0.219969;
  } else {
    return num;
  }
}

export function VolumeValue(number, unit) {
  if (number === null || number === undefined) return number; 
  const num = Number(number);
  if (isNaN(num)) return;
	if (unit === "usGal") {
		return (num * 0.264172).toFixed(2);
	} else if (unit === "impGal") {
		return (num * 0.219969).toFixed(2);
	} else {
		return num;
	}
}
